export default __webpack_public_path__ + "static/media/element_3.a0213804.avif";